export const UserRole = {
  USER: 'user',
  VIEWER: 'viewer',
  ANALYST: 'analyst',
  AD_MANAGER: 'ad_manager',
  AUDITOR: 'auditor',
  EDITOR: 'editor',
  OWNER: 'owner',
}

export const UserRoleText = {
  [UserRole.USER]: 'ユーザー',
  [UserRole.VIEWER]: '閲覧者',
  [UserRole.ANALYST]: 'アナリスト',
  [UserRole.AD_MANAGER]: '広告編集者',
  [UserRole.AUDITOR]: '記事監査者',
  [UserRole.EDITOR]: '編集者',
  [UserRole.OWNER]: 'オーナー',
}

export const UserRoleColor = {
  [UserRole.USER]: 'olive',
  [UserRole.VIEWER]: 'yellow',
  [UserRole.ANALYST]: 'teal',
  [UserRole.AD_MANAGER]: 'green',
  [UserRole.AUDITOR]: 'pink',
  [UserRole.EDITOR]: 'orange',
  [UserRole.OWNER]: 'red',
}
